<div>
    <div *ngIf="destinations.length === 0">
        <p class="muted">
            <i class="fa fa-circle-info"></i> No se tiene lista de precios
        </p>
    </div>
    <div>
        <div class="row" id="options-other-filters">
            <div class="col-sm form-group">
                <label for="filterVendors" class="form-label">Filtrar</label>
                <div class="input-group input-group-sm">
                    <input
                        type="text"
                        id="filter"
                        [(ngModel)]="filterWord"
                        (input)="onInputChange($event)"
                        placeholder="Filtra destino por nombre"
                        name="filter"
                        class="form-control"
                    />
                    <button class="btn btn-primary" (click)="searching()">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
        <p class="muted">
            <i class="fa fa-circle-info"></i> Selecciona un destino
        </p>
    </div>
    <div class="row">
        <div class="mb-4">
            <!-- <ul class="px-0 border rounded">
                <ng-container *ngFor="let item of pagination.filter">
                    <li (click)="setPriceListSelected(item)" style="list-style-type: none; cursor: pointer;" class="hover:bg-body px-2" [class.bg-blue-600]="item.id==destinationsSelectedId">
                        <div class="d-flex flex-row justify-between items-center py-2">
                            <div>
                                {{item.name}}
                            </div>
                            <div>
                                {{item.id==destinationsSelectedId}}
                            </div>
                        </div>
                    </li>
                </ng-container>
            </ul> -->
            <table class="table table-hover table-responsive">
                <thead>
                    <tr class="text-left">
                        <th>Nombre</th>
                        <th class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of pagination.filter">
                        <tr (click)="setDestinationSelected(item)" class="cursor-pointer px-2"
                        >
                            <td [class.bg-blue-50]="item.id==destinationSelectedId"
                            [class.font-bold]="item.id==destinationSelectedId"
                            >
                                <div class="input-group-sm d-flex flex-row" *ngIf="editDestination[item.id]">
                                    <input type="text" 
                                        placeholder="Nombre" 
                                        class="form-control"
                                        [(ngModel)]="item.name"
                                        >
                                    <button class="btn btn-success" (click)="updateList(item)"
                                        >
                                        <i class="fa fa-save" ></i>
                                    </button>
                                </div>
                                <div *ngIf="!editDestination[item.id]">
                                    {{item.name}}
                                </div>
                            </td>
                            <td class="text-right"
                            [class.bg-blue-50]="item.id==destinationSelectedId"
                            [class.font-bold]="item.id==destinationSelectedId"
                            >
                                <div class="d-flex flex-wrap items-center justify-center gap-1">
                                    <span class="a-hover" (click)="editingName(item)">
                                        <i class="fa fa-edit text-primary"></i>
                                    </span>
                                    <span  class="a-hover" (click)="deleteList(item)">
                                        <i class="fa fa-trash text-danger"></i>
                                    </span>
                                </div>
                            </td>
                        </tr>
                        <tr class="tr-middle" *ngIf="loading">
                            <td colspan="4">
                                <app-loading-animation [height]="'5rem'"></app-loading-animation>
                                <p class="display-6">Cargando</p>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
             <app-pagination-custom [elements]="pagination"></app-pagination-custom>
        </div>
    </div>
</div>